export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7471.b6dc81c2.jpg";